<template>
  <nav class="tab-nav" :aria-label="ariaLabel">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      class="tab-nav__tab"
      :class="{ 'is-active': modelValue === tab.id }"
      :aria-selected="modelValue === tab.id"
      role="tab"
      @click="$emit('update:modelValue', tab.id)"
    >
      <i v-if="tab.icon" class="material-icons-round tab-nav__icon">{{ tab.icon }}</i>
      <span class="tab-nav__label">{{ tab.label }}</span>
      <span v-if="tab.count != null" class="tab-nav__count">{{ tab.count }}</span>
    </button>
  </nav>
</template>

<script>
export default {
  name: "TabNav",
  props: {
    modelValue: { type: String, required: true },
    tabs: { type: Array, required: true, default: () => [] },
    ariaLabel: { type: String, default: 'Tabs' },
  },
  emits: ['update:modelValue'],
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.tab-nav {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  background: $p-panel-alt;
  border: 1px solid $p-line;
  border-radius: $p-radius;
}

.tab-nav__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  background: transparent;
  border: 0;
  border-radius: $p-radius-sm;
  cursor: pointer;
  font-family: $p-font-body;
  font-size: 13px;
  font-weight: 600;
  color: $p-ink-mid;
  transition: background 0.12s, color 0.12s, box-shadow 0.12s;

  &:hover:not(.is-active) {
    background: $p-panel;
    color: $p-ink;
  }

  &.is-active {
    background: $p-ink;
    color: $p-point;
    font-weight: 800;
    box-shadow: 0 2px 6px rgba(31, 27, 20, 0.18);

    .tab-nav__icon { color: $p-point; }
    .tab-nav__count {
      background: $p-point-soft;
      color: $p-point-deep;
    }
  }
}

.tab-nav__icon {
  font-size: 16px !important;
  color: $p-ink-mid;
}

.tab-nav__count {
  font-family: $p-font-mono;
  font-size: 11px;
  font-weight: 800;
  padding: 1px 7px;
  border-radius: 999px;
  background: $p-panel;
  color: $p-ink-mid;
  border: 1px solid $p-line;
  margin-left: 4px;
}
</style>
